"use strict";

exports.__esModule = true;
exports.config = void 0;

const config = (brandcode, environment) => ({
  profile: `${brandcode}-${environment}`,
  brandcode,
  environment,
  debugEnabled: {
    type: 'cookie',
    value: '1',
    key: '_mhtc_debug'
  },
  spaModeEnabled: true,
  enableTestMode: '_mhtc_tm',
  tagManager: {
    type: 'Gtm',
    gtmid: 'GTM-K5CX4PZ',
    environment: 'dev'
  },
  glitrTracker: {
    name: 'production',
    legacyDataFormat: true,
    uri: 'https://preview-mhlu.mhtr.be',
    heartbeat: {
      enabled: true,
      defaultTimeOut: 5000,
      lookAroundSpeed: 1000,
      uri: 'https://previewh-mhlu.mhtr.be'
    },
    consentInfo: {
      requiredFlags: ['consentcookies', 'consentmeasureadperformance', 'consentmeasurecontentperformance'],
      sensitiveProperties: ['identityaccountid']
    }
  },
  allowedPropertiesForEnrichment: ['transactionstatus'],
  dataLayer: {
    application: 'www',
    brandcode,
    environment,
    type: 'subscriptionshop',
    platform: null,
    pagetype: 'subscriptionshop',
    accessloginshown: false,
    accesswalltype: 'none',
    pagesecure: false,
    pagesecuretype: 'open',
    subscriptiontype: null,
    previouspagetypes: []
  }
});

exports.config = config;